import { render, staticRenderFns } from "./DeleteGroupRecord.vue?vue&type=template&id=639297f4"
import script from "./DeleteGroupRecord.vue?vue&type=script&lang=js"
export * from "./DeleteGroupRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports